import { createContext, ReactNode, useMemo, useReducer } from "react";

import {
  ChatContextAction,
  chatReducer,
  ChatState,
  initialState,
} from "./state";

interface ChatContextType extends ChatState {
  setContext: (action: ChatContextAction) => void;
}

export const ChatContext = createContext<ChatContextType | undefined>(
  undefined,
);

export function ChatProvider({ children }: { children: ReactNode }) {
  const [state, setContext] = useReducer(chatReducer, initialState);

  const values = useMemo(
    () => ({
      ...state,
      setContext,
    }),
    [state, setContext],
  );

  return <ChatContext.Provider value={values}>{children}</ChatContext.Provider>;
}
